"use strict";

module.exports = ['$resource', function ( $resource ) {

    let Contact = $resource('/contacts/:id',
        {
            id: '@id'
        },
        {
            'save': {method:'POST'},
            'update': {method: 'PATCH'},
            'delete': {method: 'DELETE'}
        }
    );

    var save = Contact.save;

    // Required for "easy" .save in controllers
    Contact.save = function ( ...args ) {

        if( args[0].id ) {
            this.update.apply(this, args);
        } else {
            save.apply(this, args);
        }
    };

    return Contact;
}];
